import type { Router } from 'vue-router';
import type { LocationQuery } from 'vue-router';

/**
 * Удаляет указанные query-параметры из URL
 * @param router - Экземпляр Vue Router
 * @param paramNames - Массив названий параметров для удаления
 */
export const removeQueryParams = (router: Router, paramNames: string[]): void  => {
  const currentQuery: LocationQuery = { ...router.currentRoute.value.query };
  paramNames.forEach((param: string) => {
    delete currentQuery[param];
  });

  router.replace({ query: currentQuery });
};
